import React, { useState, useEffect } from 'react';
import SideBar from '../Components/SideBar';
import {
  fetchAdminTerminalsRequests,
  updateTerminalsStatus,
  fetchTerminalById,
  getCityAdminTerminalRequests
} from '../Services/SuperAdminApi';
import forumStatus from '../Constants/forumStatus';
import { useTranslation } from "react-i18next";

const formatDate = (isoDate, lang = 'en') => {
  return new Date(isoDate).toLocaleString(lang === 'de' ? 'de-DE' : 'en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false, // This ensures 24-hour format like "12:04", not "12:04 PM"
  });
};

const userId = localStorage.getItem('userId')
const tabsIdsToApis = {
  terminal: {
    fetchAll: fetchAdminTerminalsRequests,
    fetchById: fetchTerminalById,
    updateStatus: updateTerminalsStatus,
    getCityAdminRequests: getCityAdminTerminalRequests
  }
}

const CityAdminRequests = () => {
  const { t, i18n } = useTranslation();
  const tabs = [
    { id: "terminal", label: "Terminal", content: "Terminal configs request" },

  ];
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [modalstatus, setModalStatus] = useState(null);
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const [list, setList] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showRequestModal, setRequestModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false)
  const [successModal, setSuccessModal] = useState(false);
  const [openSection, setOpenSection] = useState(null);

  const renderModalContent = () => {
    // Increase max height for accordions and reduce dropdown height
    const accordionMaxHeight = "max-h-96"; // ~384px, increased for more content

    switch (activeTab) {
      case "terminal":
        return (
          <>
            {/* Terminal Accordion */}
            <details
              open={openSection === "terminal"}
              className="mb-2 border rounded"
            >
              <summary
                className="cursor-pointer px-4 py-1 font-semibold bg-gray-100 hover:bg-gray-200"
                onClick={e => {
                  e.preventDefault();
                  setOpenSection(openSection === "terminal" ? null : "terminal");
                }}
              >
                Terminal
              </summary>
              <div
                className={`px-4 py-2 overflow-x-auto ${accordionMaxHeight}`}
                onClick={e => e.stopPropagation()}
              >
                <table className="min-w-full text-xs text-gray-800 border">
                  <thead>
                    <tr className="bg-gray-50">
                      <th className="px-2 py-1 font-semibold border">{t("header")}</th>
                      <th className="px-2 py-1 font-semibold border">Logo</th>
                      <th className="px-2 py-1 font-semibold border">{t("city")}</th>
                      <th className="px-2 py-1 font-semibold border">{t("map_link")}</th>
                      <th className="px-2 py-1 font-semibold border">{t("latitude")}</th>
                      <th className="px-2 py-1 font-semibold border">{t("longitude")}</th>
                      <th className="px-2 py-1 font-semibold border">{t("template")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="px-2 py-1 border">
                        {selectedRequest.header_url ? (
                          <span
                            className="text-blue-600 underline cursor-pointer"
                            onClick={() => window.open(selectedRequest.header_url, "_blank")}
                          >
                            Header
                          </span>
                        ) : "-"}
                      </td>
                      <td className="px-2 py-1 border">
                        {selectedRequest.logo_url ? (
                          <span
                            className="text-blue-600 underline cursor-pointer"
                            onClick={() => window.open(selectedRequest.logo_url, "_blank")}
                          >
                            Logo
                          </span>
                        ) : "-"}
                      </td>
                      <td className="px-2 py-1 border">{selectedRequest.cityName || "-"}</td>
                      <td className="px-2 py-1 border">
                        {selectedRequest.link ? (
                          <span
                            className="text-blue-600 underline cursor-pointer"
                            onClick={() => window.open(selectedRequest.link, "_blank")}
                          >
                            {t("map_link")}
                          </span>
                        ) : "-"}
                      </td>
                      <td className="px-2 py-1 border">{selectedRequest.latitude || "-"}</td>
                      <td className="px-2 py-1 border">{selectedRequest.longitude || "-"}</td>
                      <td className="px-2 py-1 border">{selectedRequest.template || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </details>


          </>
        );

    }
  }

  const renderModal = () => {
    return (
      <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
        <div
          className="bg-white p-6 rounded-2xl max-w-lg w-full relative flex flex-col"
          style={{
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <button
            className="absolute top-3 right-4 text-gray-500 hover:text-black text-2xl"
            onClick={() => setSelectedRequest(null)}
          >
            &times;
          </button>
          <h2 className="text-xl font-bold mb-2">{selectedRequest.title || selectedRequest.name}</h2>
          {selectedRequest.createdAt && (
            <p className="text-sm text-gray-500 mb-4">
              {t("createdAt")}: {formatDate(selectedRequest.createdAt)}
            </p>
          )}
          <div className="mb-6">{renderModalContent()}</div>
          {selectedRequest && (selectedRequest.userEmail || selectedRequest.createdByEmail) && (
            <div className="text-sm text-gray-500 mb-4">
              <div className="font-semibold mb-1">{t("candidate_proposed")}:</div>
              {selectedRequest.createdByUserName && <div>
                <span className="font-medium">Name:</span> {selectedRequest.createdByUserName}
              </div>}
              <div>
                <span className="font-medium">Email:</span> {selectedRequest.userEmail || selectedRequest.createdByEmail || "-"}
              </div>
            </div>
          )}

        </div>
      </div>
    )
  }

  const fetchRequestList = async (id) => {
    try {
      setList(null);
      setIsLoading(true);
      const { data } = await tabsIdsToApis[id]?.getCityAdminRequests(userId)
      if (data?.data.length) {

        setList(data.data)
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.error(e)
    }
  }

  useEffect(() => {
    fetchRequestList(activeTab)
  }, [userId]);
  const onTabClick = (id) => {
    setActiveTab(id);
    fetchRequestList(id);
  }

  const onClickRequest = async (req) => {
    let newReq = structuredClone(req);
    try {
      setIsLoading(true);
      let res = await tabsIdsToApis[activeTab]?.fetchById(req.id);
      newReq = { ...req, ...(res?.data?.data || {}) };
      setIsLoading(false);
    }
    catch (e) {
      setIsLoading(false);
      console.error(e);
    }
    setSelectedRequest(newReq);
    setRequestModal(true)
  }


  function handleAccept() {
    setModalStatus("Accepted");
    setConfirmModal(true);
    setRequestModal(false)
  }
  function handleReject() {
    setRequestModal(false)
    setModalStatus("Rejected");
    setConfirmModal(true);
  }
  const [rejectReason, setRejectReason] = useState('');
  const handelUpdateStatus = async () => {
    const params = {}
    const id = selectedRequest.id;
    setConfirmModal(false);
    if (modalstatus == "Accepted") params.status = forumStatus.statusByName.Accepted;
    else if (modalstatus == "Rejected") { params.status = forumStatus.statusByName.Rejected; params.reason = rejectReason };
    try {
      setIsLoading(true);
      await tabsIdsToApis[activeTab]?.updateStatus(id, params);
      setSuccessModal(true);
      setRejectReason('');
      setSelectedRequest(null);
      setTimeout(() => {
        setSuccessModal(false);
      }, 1000);
      fetchRequestList(activeTab);
    } catch (e) {
      setIsLoading(false);
      setRejectReason('');
      console.error(e)
    }
  }

  return (
    <div className="bg-gray-800 body-font relative min-h-screen">
      <SideBar />
      <div className="container w-auto px-5 py-2">
        {isLoading &&
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="text-white">
              {t("loading")}
            </div>
          </div>}
        <div className="max-w-4xl mx-auto p-6">
          <h2 className="text-2xl font-bold mb-4 text-white">{t("request_overview")}</h2>
          <div className="space-y-4">
            <div className="flex">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`px-4 py-2 font-medium text-md text-bold transition-all duration-200 ${activeTab === tab.id
                    ? "border-b-2 border-blue-500 text-blue-600"
                    : "text-white hover:text-blue-500"
                    }`}
                  onClick={() => onTabClick(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <div className="p-4 bg-white border border-gray-200 rounded-b-md space-y-4">
              <div className="overflow-x-auto">
                <table className="table-auto w-full text-left border-collapse">
                  <thead>
                    <tr>
                      <th className="border px-4 py-2">{t("title")}</th>
                      <th className="border px-4 py-2">{t("status")}</th>
                      <th className="border px-4 py-2">{t("createdAt")}</th>
                      <th className="border px-4 py-2">{t("action")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list && list.length > 0 ? (
                      list.map((req) => (
                        <tr>
                          <td className="border px-4 py-2">{req.title || req.name}</td>
                          <td className="border px-4 py-2">
                            {t(`${req.isApproved.toLowerCase()}`)}
                          </td>
                          <td className="border px-4 py-2 text-sm text-gray-500">
                            {req.createdAt ? formatDate(req.createdAt, i18n.language) : "--"}
                          </td>
                          <td className="border px-4 py-2">
                            <button
                              onClick={() => onClickRequest(req)}
                              className="text-blue-600 hover:underline font-medium text-sm"
                            >
                              {t("View")}
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      !isLoading && (
                        <tr>
                          <td
                            className="text-center text-gray-500 text-sm py-4"
                            colSpan={3}
                          >
                            {t("No_requests_found")}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>


          </div>
          {
            successModal && (
              <div className={`fixed top-4 right-2 p-3 rounded-md text-xs ${modalstatus === "Accepted"
                ? "bg-green-100 text-green-800"
                : "bg-red-100 text-red-800"
                }`}>
                {`Request ${modalstatus === "Accepted" ? "accepted" : "rejected"} successfully!`}
              </div>
            )
          }

          {
            confirmModal && (
              <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50'>
                <div className="absolute rounded-md top-40  w-[50%] p-4 bg-white shadow-lg">
                  <div className='w-full flex items-center justify-end cursor-pointer' onClick={() => { setConfirmModal(false); setSelectedRequest(null) }}>
                    <button
                      className="absolute top-3 right-4 text-gray-500 hover:text-black text-2xl"
                    >
                      &times;
                    </button>
                  </div>
                  <div className="flex items-center flex-col gap-4 justify-center h-full">
                    <p className={`text-lg text-bold align-left ${modalstatus === "Accepted" ? "text-green-600" : "text-red-600"}`}>
                      {`Do you want to ${modalstatus === "Accepted" ? "accept" : "reject"} the request?`}
                    </p>
                    {modalstatus !== "Accepted" && <textarea
                      rows={4}
                      value={rejectReason}
                      onChange={(e) => setRejectReason(e.target.value)}
                      placeholder="Please enter your reason"
                      className="w-full border border-gray-300 rounded px-3 py-2 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    }
                  </div>
                  <div className='w-full flex items-center justify-center gap-3 mt-4'>
                    <button className='border rounded-md p-1 w-20 bg-red-600 text-white font-bold' onClick={handelUpdateStatus}>confirm</button>
                  </div>
                </div>
              </div>
            )
          }
          {/* Modal */}
          {selectedRequest && showRequestModal && renderModal()}
        </div>
      </div>
    </div>
  );
}

export default CityAdminRequests;
